export const personConstants = {
    PERSON_FETCH: 'PERSON_FETCH',
    PERSON_LOADING_SPINNER: 'PERSON_LOADING_SPINNER'
};